import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const LOGO_BANDEROLLE = "https://customer-assets-lxgj4vgw.emergentagent.net/job_ai-skills-platform-3/artifacts/mivuccq9_1%20er%20FESTIVAL%20AMATOUR%202027%20-banderolle.png";
export const LOGO_MARK = "https://customer-assets-lxgj4vgw.emergentagent.net/job_ai-skills-platform-3/artifacts/eaffnxst_LOGO%20AMATOUR.png";

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("amatour_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
export default client;

export const authApi = {
  login: (username, password) => client.post("/auth/login", { username, password }),
  me: () => client.get("/auth/me"),
  changePassword: (old_password, new_password) => client.post("/auth/change-password", { old_password, new_password }),
  listUsers: () => client.get("/auth/users"),
  createUser: (payload) => client.post("/auth/users", payload),
  deleteUser: (id) => client.delete(`/auth/users/${id}`),
};

export const trackHit = (path) => client.post("/analytics/hit", { path, referrer: document.referrer || "" }).catch(() => {});
